<div class="dashboard-wrapper flex-column" *ngIf="data">
  <div class="overview-card-wrapper" *ngIf="organization === null || organization.organizationType.id !== 2">
    <div class="overview-card"><i class="material-icons">supervisor_account</i>Users: {{data.users.usersCount}}</div>
    <div class="overview-card"><i class="material-icons">verified_user</i>Admins: {{data.users.adminsCount}}</div>
    <div class="overview-card" *ngIf="organization === null"><i class="material-icons">other_houses</i>Companies: {{data.numberOfCompanies}}</div>
    <div class="overview-card"><i class="material-icons">house</i>Sites: {{data.numberOfSites}}</div>
  </div>

  <lib-prod-header [title]="'Cars'" [icon]="'directions_car_filled'" class="dashboard-hub-wrapper" >
    <app-cars-current-statistics [data]="data" [inputAction$]="reloadCars">
    </app-cars-current-statistics>
  </lib-prod-header>

  <lib-prod-header [title]="'Antennas'" [icon]="'settings_input_antenna'" class="dashboard-hub-wrapper" >
    <div class="site-hub-list-wrapper">
      <div class="site-hub-wrapper" *ngFor="let siteHubs of data.hubs">
        <div class="site-name">{{siteHubs.companyName}} / {{siteHubs.name}} <wbr> ({{siteHubs.all}} hubs)</div>
        <div class="site-hub-bar-wrapper">
          <span>{{siteHubs.all ? siteHubs.inactiveCount + ' (' + (siteHubs.inactiveCount*100/siteHubs.all).toFixed() + '%)' : '' }}</span>
          <mat-progress-bar [ngClass]="{empty: !siteHubs.all}" value="{{siteHubs.inactiveCount*100 / siteHubs.all}}"></mat-progress-bar>
          <span>{{siteHubs.all ? siteHubs.activeCount + ' (' + (siteHubs.activeCount*100/siteHubs.all).toFixed() + '%)' : '' }}</span>
        </div>
      </div>
    </div>
  </lib-prod-header>
</div>
